import React from "react";
import Utils from '../Utils';
import {__API_ROOMS_URL__} from '../../consts/consts';
import Storage from '../Storage';

import IntlMessages from '../../helpers/IntlMessages';
import './style.css';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import SponsorCarousel from '../SponsorsCarousel';
import LiveFeed from '../LiveFeed';
import Tabs from 'react-bootstrap/Tabs';
import Spinner from 'react-bootstrap/Spinner';
import Tab from 'react-bootstrap/Tab';
import {Button,ButtonGroup} from 'react-bootstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import ApiCalls from "../ApiCalls";
import LiveStreamSelectionTabs from './LiveStreamSelectionTabs';
import {
    withRouter
  } from 'react-router-dom';

class LiveStream extends React.Component {

    constructor(props){
        super(props);
        this.state = { 
            windowWidth: window.document.body.clientWidth,
            previousWindowWidth:window.document.body.clientWidth,
            scaleModalFactor:1,
            myStyle:null,
            clicked:false,
            showModal:false,
            renderModal:'',
            url:'',
            roomList:null,
            isLoading:true,
            roomSelected:null,
            roomLinkSelected:null };
        
    }

    componentDidMount(){
        this.setState()
        this.setRoomsTabs();
    }

    componentDidUpdate(prevProps) {
		//Este metodo se ejecuta cuando redux cambia el estado, me fijo si es otro expositor y renderizo
		 if (prevProps.roomSelectedId != this.props.roomSelectedId)
		 	this.setRoomsTabs();
	} 



   
  
    getRoomLink(room){
        if (room == null)
            return "";
        return room.videoLink;
        
    }

    onRoomClick(ev){
       
		this.props.history.push({pathname:"/liveStream/"+ev.currentTarget.attributes.roomId.value});
        // const roomId = ev.currentTarget.attributes.roomId.value;
        // let room = this.state.roomList.find(r=>r.id == roomId);
        // this.setState({roomSelected:room,roomLinkSelected:room.videoLink});

    }

    componentWillUnmount(){
        Storage.setLiveStreamRoomId(null);
    }


    setRoomsTabs(){
        var me = this;

		let roomSelectedId =  me.props.roomSelectedId;
        if (roomSelectedId != null){
            let roomSelected = Storage.getRooms().find( room => room.id == roomSelectedId);
            Storage.setLiveStreamRoomId(roomSelected.id);

            this.setState({roomList : Storage.getRooms(),
                isLoading: false,
                roomSelected:roomSelected!=null?roomSelected:null,
                roomLinkSelected:roomSelected!=null?roomSelected.videoLink:null})
        }

    }

    // setRoomTabs(){
	// 	var me = this;
	// 	ApiCalls.getRooms().then( (pckge)=>{
	// 		pckge = pckge.sort((a,b)=>
	// 							   a.order != b.order ? 
	// 							   a.order-b.order
	// 							   :
	// 							   a.description.localeCompare(b.description))
	// 		 //Me fijo si se seleccionó un room en la url
	// 		//  let urlParams = new URLSearchParams(window.location.search);
	// 		//  let roomSelectedId = urlParams.get('roomId');
	// 		let roomSelectedId =  me.props.roomSelectedId;
	// 		 let roomSelected = pckge.find( room => room.id == roomSelectedId)
			 
	// 		 if (roomSelected == undefined) {
	// 			 roomSelected = pckge[0];
	// 			 if (roomSelectedId != null)
	// 				 console.error("ERROR: No existe room con ID: ",roomSelectedId,". Visualizando: ",roomSelected.name)
	// 				 window.history.pushState({},null,"/liveStream/liveStreamView")
	// 		 }
    //          ApiCalls.logOnLiveStreamClick(roomSelected.name);
    //          console.log("se selecionó: "+this.getRoomName(roomSelected))
	// 		 this.setState({roomList : pckge,
	// 			 isLoading: false,
	// 			 roomSelected:roomSelected!=null?roomSelected:null,
	// 			 roomLinkSelected:roomSelected!=null?roomSelected.videoLink:null})
	// 		 }
	// 	)
	// }
  
    onLivePollingClick(){
        Utils.logOnClick("360Tour",22984,  "{action:onLivePollClick,idRegistration:"+Storage.getIdRegistration()+"}");
        this.setState({hasCheckinLivePolling:true})
    }
    render() {
        if ( this.state.isLoading == true)
            return(<Spinner></Spinner>);
        if ( this.state.roomSelected == null)
            return(<><div><br/><h1>No hay salones</h1></div></>);

        return (
            <Container className="livestream-background" fluid >
                 <Row className="livestream-row">
                 <Col sm={!this.props.displayingInMiniPlayer?8:12} >
                      <LiveStreamSelectionTabs roomSelected={this.state.roomSelected} onRoomClick={(ev)=> this.onRoomClick(ev)} />
                </Col>
                    <Col sm={4}>
                    <SponsorCarousel className={'col40'} />
                        <div className="livestream-tabs" >
                        <Tabs defaultActiveKey="liveFeed"  transition={false} id="interaction-tabs"   >
                        <Tab eventKey="liveFeed"  title={<IntlMessages id="dashboards.comment-live"/>}>
                                <LiveFeed height="40vh" roomId={this.state.roomSelected.id} />
                            </Tab> 
                        
                            <Tab eventKey="questions" title={<IntlMessages id="dashboards.leave-question"/>} >
                            {
                                Storage.getIdEvent() == 10796
                                ?   <div>
                                        <div id="HeaderHidden"></div>
                                        <iframe src="https://app.sli.do/event/ax5s6grm" height="580" width="100%" frameBorder="0"></iframe>
                                    </div>
                                :
                                    <iframe width="100%" height="300px" src={"https://www.kingconf.com/Interactivity/VirtualEvent/SendQuestion.aspx?AcEventId="+Storage.getIdEvent()+"&Culture=es-ES&AcRoomId="+this.state.roomSelected.id}>
                                    </iframe>
                            }
                                
                            </Tab>
                            <Tab eventKey="livePolling" title="Votación en línea" >
                            {
                                this.state.hasCheckinLivePolling == true
                                ?   <iframe width="100%" height="400px"   src={"https://www.menti.com/4ncn6akzbr"}>
                                    </iframe>
                                :   <div style={{marginTop:'100px',textAlign:'center'}}>
                                        <Button onClick={()=> this.onLivePollingClick()}> Participa  haciendo click aquí</Button>
                                    </div>        
                            }
                            </Tab>
                        </Tabs> 
                        </div>                
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return { locale: state.settings.locale}
  }
  
  export default connect(mapStateToProps,null)(withRouter(LiveStream))
